import React, { useContext } from "react";
import useUsaStateOrgInput from "@/res/hooks/Form/useUsaStateOrgInput";
import { ServiceContext } from "@/res/context/ServiceContext";
import { useTranslation } from "react-i18next";

const StateOrgForm = (props) => {
    const serviceContext = useContext(ServiceContext);
    const [t] = useTranslation();

    const usaStateOrgInput = useUsaStateOrgInput({
        key: "extra.organisation", context: serviceContext, class: "small",
        label: t("site.signup._country._service.label-state-org-form"), placeholder: "label",
    });

    return (
        <div>
            { usaStateOrgInput.render() }
        </div>
    );
};

export default StateOrgForm;
